import React from "react";

interface SkeletonBoxProps {
  className?: string;
}

export const SkeletonBox: React.FC<SkeletonBoxProps> = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 ${className ?? ""}`} />
);
